// subscribeStreamChannel.js
'use strict';
import * as MessageTypes from '../serviceWorker/AppMessageTypes.js';
import { sendMessageToSW } from '../serviceWorker/helpers.js';

/**
 * Subscribe stream channel
 * @kind action
 * @param {string} {streamId} - stream id.
 * @return {Promise} Action promise.
 */
const subscribeStreamChannel =
  ({ streamId }) =>
  async dispatch => {
    if (!streamId) {
      return dispatch({ type: '' });
    }
    return sendMessageToSW({
      type: MessageTypes.SUBSCRIBE_STREAM_CHANNEL,
      payload: {
        streamId,
      },
    });
  };

export default subscribeStreamChannel;
